import { render, staticRenderFns } from "./unitDetails.vue?vue&type=template&id=db2a4922&scoped=true&"
import script from "./unitDetails.vue?vue&type=script&lang=js&"
export * from "./unitDetails.vue?vue&type=script&lang=js&"
import style0 from "./unitDetails.vue?vue&type=style&index=0&id=db2a4922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2a4922",
  null
  
)

export default component.exports